import { QueryClient, QueryClientConfig } from '@tanstack/react-query';

const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    mutations: {
      networkMode: 'offlineFirst',
      retry: false,
    },
    queries: {
      gcTime: 1000 * 60 * 60 * 24,
      networkMode: 'offlineFirst',
      refetchOnWindowFocus: true,
      staleTime: 1000 * 60,
    },
  },
};

export const queryClient = new QueryClient(queryClientConfig);
